import { TranslationMap } from '@trimble-gcs/i18n-types';

export function importTimeRemainingTranslations() {
  return {
    label: {
      text: $localize`:@@import.timeRemaining.label:Estimated time remaining: {hours} {minutes} - {transferSpeed}`,
      desc: 'Text for the time remaining in the file import dialog.',
    },
    labelLessThanMinute: {
      text: $localize`:@@import.timeRemaining.labelLessThanMinute:Estimated time remaining: less than a minute`,
      desc: 'Text for the time remaining in the file import dialog, when less than a minute is remaining.',
    },
    hours: {
      '=1': {
        text: $localize`:@@import.timeRemaining.hours.one:1 hour`,
        desc: 'Text for when the remaining time is 1 hour.',
      },
      other: {
        text: $localize`:@@import.timeRemaining.hours.other:{count} hours`,
        desc: 'Text for when the remaining time is more than 1 hour.',
      },
    },
    minutes: {
      '=1': {
        text: $localize`:@@import.timeRemaining.minutes.one:1 minute`,
        desc: 'Text for when the remaining time is 1 minute.',
      },
      other: {
        text: $localize`:@@import.timeRemaining.minutes.other:{count} minutes`,
        desc: 'Text for when the remaining time is more than 1 minute.',
      },
    },
  } satisfies TranslationMap;
}
